<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Clientes</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item active">Administración</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Clientes</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-11"></div>
                  <div class="col-md-1">
                    <div class="btn-group float-right">
                      <!-- SE LLAMA ACTUALIZACIÓN PÁGINA-->
                      <button
                        type="button"
                        class="btn bg-navy"
                        @click="getIndex()"
                      >
                        <i class="fas fa-sync-alt"></i>
                      </button>
                      <!-- SE LLAMA A LA VISTA PARA UNA TABLA DINAMICA -->
                      <button
                        type="button"
                        class="btn btn-info"
                        @click="pivotTable()"
                        v-if="
                          $store.getters.can('argentina.clientes.pivotTable')
                        "
                      >
                        <i class="fas fa-scroll"></i>
                      </button>
                      <!-- SE LLAMA EL MODAL DE CLIENTE EXPORT -->
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        data-target="#modal-form-cliente-export"
                        v-if="$store.getters.can('argentina.clientes.export')"
                      >
                        <i class="far fa-file-excel"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="create()"
                        v-if="$store.getters.can('argentina.clientes.create')"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table
                  id="users"
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead>
                    <tr>
                      <th></th>
                      <th>
                        C.U.I.T
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.n_identificacion"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Razon Social
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.razon_social"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>
                        Representante Legal<input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.representante"
                          @keyup="getIndex()"
                        />
                      </th>
                      <th>Telefono</th>
                      <th>
                        Estado
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th>Accion</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in clientes.data" :key="item.id">
                      <td>
                        <a :href="uri_docs + item.logo" target="_blank">
                          <img
                            :src="uri_docs + item.logo"
                            alt="Logo"
                            width="75"
                            class="rounded mx-auto d-block"
                          />
                        </a>
                      </td>
                      <td>{{ item.n_identificacion }}</td>
                      <td>{{ item.razon_social }}</td>
                      <td>{{ item.representante }}</td>
                      <td>{{ item.telefono }}</td>
                      <td class="text-center">
                        <span
                          v-if="
                            $store.getters.can(
                              'argentina.clientes.editarEstado'
                            )
                          "
                          class="badge"
                          data-toggle="modal"
                          data-target="#modal-form-estado"
                          style="cursor: pointer"
                          v-bind:class="[
                            item.estado == 1 ? 'badge-success' : 'badge-danger',
                          ]"
                          @click="llenarModal(item.id, item.estado)"
                        >
                          {{ item.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                        </span>
                        <span
                          v-else
                          class="badge"
                          v-bind:class="[
                            item.estado == 1 ? 'badge-success' : 'badge-danger',
                          ]"
                        >
                          {{ item.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                        </span>
                        <br />
                        <span
                          v-if="
                            item.com_anticipos &&
                            item.com_anticipos.some(
                              (anticipo) =>
                                anticipo.link_documento == null ||
                                anticipo.link_documento == ''
                            )
                          "
                          class="badge badge-warning"
                        >
                          No tiene documento los anticipos
                        </span>
                      </td>
                      <td style="width: 50px">
                        <div class="btn-group float-right">
                          <button
                            type="button"
                            class="btn btn-sm bg-navy"
                            v-if="$store.getters.can('argentina.clientes.edit')"
                            @click="edit(item)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            v-if="
                              $store.getters.can('argentina.clientes.delete')
                            "
                            @click="destroy(item.id)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="clientes.total">
                  <p>
                    Mostrando del <b>{{ clientes.from }}</b> al
                    <b>{{ clientes.to }}</b> de un total:
                    <b>{{ clientes.total }}</b> Registros
                  </p>
                </div>
                <div class="float-left" v-else>
                  <p>
                    <span class="badge badge-danger">
                      No hay registros para mostrar
                    </span>
                  </p>
                </div>
                <pagination
                  :data="clientes"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  class="float-right m-0"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
        <ClienteEstado ref="ClienteEstado" />
        <ClienteExport ref="ClienteExport" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Loading from "../../../../components/Loading";
import ClienteEstado from "./ClienteEstado";
import ClienteExport from "./ClienteExport";

export default {
  name: "Cliente",
  components: {
    pagination,
    Loading,
    ClienteEstado,
    ClienteExport,
  },
  data() {
    return {
      cargando: false,
      filtros: {
        n_identificacion: null,
        razon_social: null,
        representante: null,
        tel1: null,
        pais_id: 3,
      },
      clientes: {},
      listasForms: {
        estados: [],
      },
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      axios
        .get("/api/argentina/clientes?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.clientes = response.data;
          this.cargando = false;
        });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    destroy(id) {
      this.$swal({
        title: "Esta seguro de eliminar este Cliente?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios.delete("/api/argentina/clientes/" + id).then(() => {
            this.getIndex();
            this.$swal({
              icon: "success",
              title: "Se elimino el Cliente exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          });
        }
      });
    },

    llenarModal(id, estado) {
      if (this.$store.getters.can("argentina.clientes.editarEstado")) {
        this.$refs.ClienteEstado.llenar_modal(id, estado);
      }
    },

    create() {
      return this.$router.push({
        name: "/Argentina/Admin/ClienteForm",
        params: { accion: "Crear", id: 0 },
      });
    },

    edit(cliente) {
      return this.$router.push({
        name: "/Argentina/Admin/ClienteForm",
        params: { accion: "Editar", data_edit: cliente, id: cliente.id },
      });
    },

    pivotTable() {
      return this.$router.push({
        name: "/Argentina/Admin/ClientePivotTable",
      });
    },
  },

  mounted() {
    this.getIndex();
    this.getEstados();
  },
};
</script>
